.cf{aspect-ratio:1/1;}